import { vars } from '@etg/wings';
import { css, etiColors } from '@eti/styles';
export const travelerList = css`
  display: flex;
  flex: 1;
  gap: 8px;
  list-style: none;
  padding: 8px;
`;
export const listItem = css`
  flex: 1;
  list-style: none;
`;
export const carouselWrapper = css`
  overflow-x: auto;
  width: 100%;
`;
export const singleTravelerWrapper = css`
  flex: 1;
  padding: 8px;
`;
export const nameText = css`
  color: ${vars.colors.text.primary};
  display: flex;
  text-align: left;
  white-space: normal;
  word-break: break-word;
`;
export const buttonFlex = css`
  flex: 1;
  padding-inline: 8px;

  & > span {
    width: 100%;
  }
`;
export const inlineFlex = css`
  flex: 1;
  padding: 8px;
`;
export const activeBorder = css`
  border-color: ${vars.colors.inputs.main};
  transition: border-color 0.3s ease;
`;
export const inactiveBorder = css`
  border-color: ${vars.colors.divider};
`;
export const justifyBetween = css`
  justify-content: space-between;
  width: 100%;
`;
export const blackText = css`
  color: ${vars.colors.text.primary};
`;
export const blackTextButton = css`
  color: ${vars.colors.text.primary};
  text-align: left;
  white-space: normal;
  word-break: break-word;
`;
export const travelerButtonMobile = css`
  display: flex;
  height: 56px;
  justify-content: flex-start;
  padding-inline: 10px;
  width: 100%;
`;
export const mobiletravelerdetails = css`
  display: block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const selectSeatLabel = css`
  width: max-content;
`;
export const travelerListItem = css`
  flex: 1;
`;
export const fadeIn = css`
  animation: fadeIn 0.3s ease-in-out;
  opacity: 1;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.98);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
export const inlineWrapper = css`
  background: ${etiColors.white};
  border: 1px solid ${vars.colors.divider};
  border-radius: 15px;
  justify-content: space-around;
  width: 100%;
`;
export const travelerButtonDesktop = css`
  padding: 16px;
  width: inherit;
`;
export const inlinePadding = css`
  flex: 1;
  padding: 8px;
`;
export const headingStyles = css`
  padding-top: 16px;
`;
export const travelerDesktopContainer = css`
  width: 300px;
`;
export const travelerButtonDesktopScrollable = css`
  max-height: 500px;
  overflow-y: auto;
  width: inherit;
`;
export const nonInteractiveTextStyles = css`
  pointer-events: none;
`;
//# sourceMappingURL=styles.js.map